module.exports = __webpack_public_path__ + "img/sinbi2a.4949c5ad.jpg";